module.exports = __webpack_public_path__ + "static/media/emoji_crying_face.ac3b2332.svg";